import React from "react";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import ReusableCheckBox from "../../../Component/BasicComponents/ReusableCheckbox";

type Props = {
  handleSubmit: () => void;
  toggle: () => void;
  modalStatus: string;
};

function AddTerritoryTown({ handleSubmit, toggle, modalStatus }: Props) {
  const checkData = [{ label: "Only NCA", value: "mandatory", checked: false }];

  const handleCheck = () => {
    console.log("item check");
  };

  return (
    <div>
      <CustomInput
        label="Town*"
        type="text"
        //   value={leaveTo}
        style={{
          backgroundColor: "transparent",
          border: "0.2px solid #d4d4d4",
          flex: 1,
        }}
        // onChange={(e) => handleChange(e, "LeaveReason")}
        onChange={(e) => console.log(e, "LeaveTo")}
      />
      <ReusableDropdown
        options={[]}
        onChange={(value: any) => {
          console.log("Selected leave type:", value);
          // setSelectedLeaveStatus(value); // Store only the ID as a number
        }}
        DropdownHeading="Assign To Trip Type"
        //   value={selectedLeaveStatus?.toString()}
      />
      <ReusableDropdown
        options={[]}
        onChange={(value: any) => {
          console.log("Selected leave type:", value);
          // setSelectedLeaveStatus(value); // Store only the ID as a number
        }}
        DropdownHeading="Other Trip Type"
        //   value={selectedLeaveStatus?.toString()}
      />
      <div style={{ marginLeft: "-15px" }}>
        <ReusableCheckBox data={checkData} onCheckedChange={handleCheck} />
      </div>
      <div style={{ marginTop: "15px" }}>
        <button onClick={handleSubmit} className="btn btn-primary">
          Submit
        </button>
        <button
          onClick={() => toggle()}
          className="btn btn-light"
          style={{ color: "gray", marginLeft: "10px" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default AddTerritoryTown;
